/**
 * Config/callbacks for apiClient - avoids circular deps with redux store.
 * App.tsx sets the 401 handler after mount.
 */
type On401Callback = () => void;

let on401: On401Callback | null = null;

export function setOn401Handler(callback: On401Callback) {
  on401 = callback;
}

export function getOn401Handler(): On401Callback | null {
  return on401;
}
